import { Injectable } from '@angular/core';
import { AbstractReadOnlyDataProvider } from '@epicuro-next/data-providers/base-data-provider';
import { ProductBasketService } from '@epicuro-next/state/p-basket-state';
import { UnwrapObservable } from '@epicuro-next/utilities';
import { SearchQuery } from 'graphql-api/gql-api-interfaces';
import { Observable } from 'rxjs';

export type ProductBasketProviderResultType = UnwrapObservable<
  ReturnType<typeof ProductBasketService.prototype.getProducts>
>;

@Injectable()
export class ProductBasketProviderService
  implements AbstractReadOnlyDataProvider<ProductBasketProviderResultType>
{
  constructor(private readonly productBasketService: ProductBasketService) {}

  public read(
    searchQuery: SearchQuery,
  ): Observable<ProductBasketProviderResultType> {
    return this.productBasketService.getProducts(searchQuery);
  }
}
